import { pipe, Either, Task } from "fp";

import { type, creator, reducer, effects } from "~/Action";
import * as Data from "~/Data";
import * as Document from "~/Document";

export namespace Requested {
  export const { TYPE, create, reduce } = pipe(
    type("Documents requested" as const),
    reducer(
      ({ state }) =>
        (state.documents.store = Data.Store.requested(state.documents.store))
    ),
    effects(({ dispatch, state: { context, companies } }) =>
      pipe(
        Document.Request.Get.request(companies.current)(context),
        Task.map((documents) => dispatch(Received.create(documents)))
      )()
    )
  );
}

export namespace Received {
  export const { TYPE, create, reduce } = pipe(
    type("Documents received" as const),
    creator(
      (documents?: Either.ErrorOr<Data.Cache.Cache<Document.Document>>) => ({
        documents,
      })
    ),
    reducer(
      ({ state, action: { documents } }) =>
        (state.documents.store = pipe(
          state.documents.store,
          Data.Store.received(documents)
        ) as typeof state.documents.store)
    )
  );
}
